import { defineStore } from "pinia";
import {
  api,
  type ResultOkRef,
  Success,
  watchRequest,
  type Result,
} from "../api";
import {
  BlueberryResponseSchema,
  type BlueberryResponse,
  type BlueberryUpdatePayload,
} from "../schemas/blueberry";
import { markRaw } from "vue";

class BlueberryApi {
  private readonly url = "/blueberry/";
  private cached?: ResultOkRef<Success<BlueberryResponse>>;

  getBlueberry(): ResultOkRef<Success<BlueberryResponse>> {
    if (!this.cached) {
      this.cached = watchRequest(this.url, BlueberryResponseSchema);
    }
    return this.cached;
  }

  updateBlueberry(payload: BlueberryUpdatePayload): Promise<Result<BlueberryResponse>> {
    const updatedPayload = {
      ...payload,
      ...(payload.price !== undefined ? { price: payload.price * 100 } : {}),
    };
    return api.patch(this.url, BlueberryResponseSchema, updatedPayload);
  }
}

const store = defineStore("blueberry", () => ({
  api: markRaw(new BlueberryApi()),
}));

export function useBlueberry() {
  return store().api;
}
